/* Maison Sabelle footer: wordmark reveal on scroll, and the phone accordion.
   Without JS the footer renders fully open and the wordmark is simply in place. */
(() => {
  if (customElements.get('sabelle-footer')) return;

  const PHONE = window.matchMedia('(max-width: 749px)');
  const CALM = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SabelleFooter extends HTMLElement {
    connectedCallback() {
      this.details = [...this.querySelectorAll('details.sab-foot__col')];
      this.onBreakpoint = () => this.syncDetails();
      this.onSummary = (event) => {
        if (!PHONE.matches) event.preventDefault();
      };

      this.details.forEach((d) => d.querySelector('summary')?.addEventListener('click', this.onSummary));
      PHONE.addEventListener('change', this.onBreakpoint);
      this.syncDetails();
      this.setupReveal();

      // Bring the thank-you or error line into view after Shopify's redirect.
      const msg = this.querySelector('.sab-foot__msg');
      if (msg && /customer_posted=true|#SabelleInvite/.test(location.href + location.hash)) {
        msg.scrollIntoView({ block: 'center', behavior: 'auto' });
        if (msg.tabIndex === -1) msg.focus({ preventScroll: true });
      }
    }

    disconnectedCallback() {
      PHONE.removeEventListener('change', this.onBreakpoint);
      this.observer?.disconnect();
    }

    syncDetails() {
      this.details.forEach((d) => {
        d.open = !PHONE.matches;
      });
    }

    setupReveal() {
      const mark = this.querySelector('.sab-foot__mark');
      if (!mark || CALM.matches || !('IntersectionObserver' in window)) return;
      this.classList.add('sab-foot--anim');
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.classList.add('is-in');
            this.observer.disconnect();
          }
        },
        { threshold: 0.35 }
      );
      this.observer.observe(mark);
    }
  }

  customElements.define('sabelle-footer', SabelleFooter);
})();
